<div [ngClass]="{'card mb-2 wow detalle-cliente': true, disabledContent: !enabledMaster}">
  <div class="card-body justify-content-between">
    <div class="row filtros-body">
      <div class="col">
        <h5>Documento pendiente por pagar</h5>
      </div>
    </div>
    <div class="table-responsive">
      <form [formGroup]='formDocs' novalidate>
        <div class="row filtros-body" *ngIf="esTipoDeclaranteVendedor">
          <div class="col" style="max-width: 150px;">
            <div class="md-form">
              <input value="" type="text" id="rutdeclara" class="form-control" placeholder="" required #rutdeclara
                formControlName="rutDeclarante" formatRut />
              <label for="rutdeclara">RUT</label>
              <div *ngIf="
                  formDocs.get('rutDeclarante').invalid &&
                  (formDocs.get('rutDeclarante').dirty ||
                  formDocs.get('rutDeclarante').touched)
              ">
                <mdb-error *ngIf="formDocs.get('rutDeclarante').hasError('required')">
                  Ingrese rut declarante
                </mdb-error>
              </div>
            </div>
          </div>
          <div class="col d-flex">
            <button mdbBtn type="button" class="btn-cuadrado" color="secondary" mdbWavesEffect
              (click)="abrirModalSeleccionarCliente()">
              <mdb-icon fas icon="search"></mdb-icon>
            </button>
            <h6 class="text-info" style="display: contents;">
              {{ clienteSeleccionado?.razon_social }}
            </h6>
          </div>
        </div>
      </form>

      <table [ngClass]="{'table table-striped table-hover table-sm align-middle': true, disabledContent: !enabled}">
        <thead class="grey lighten-2">
          <tr>
            <th scope="col">
              <mdb-checkbox (change)="checkAllDocPendientesChange($event)"></mdb-checkbox>
            </th>
            <th scope="col">Nro. Doc</th>
            <th scope="col">Tipo pago</th>
            <th scope="col">Ref. Doc. Nro.</th>
            <th scope="col">Folio Ref.</th>
            <th scope="col">Vendedor</th>
            <th scope="col">Emisión</th>
            <th scope="col">Vencimiento</th>
            <th scope="col" class="text-right">Monto</th>
            <th scope="col" class="text-center">Pagos</th>
            <th scope="col" class="text-center">Abonar</th>
            <th scope="col" class="text-right">Deuda</th>
            <th scope="col" class="text-center">Recorrido</th>
            <th scope="col" class="text-center">Estado Rec.</th>
          </tr>
        </thead>
        <tbody>
          <tr *ngFor="let docto of documentosPendientes">
            <td>
              <mdb-checkbox [checked]="docto.seleccion" (change)='checkDocPendiente(docto)'></mdb-checkbox>
            </td>
            <td>{{docto.folio == 0 ? "": docto.folio}}</td>
            <td>{{docto.tipo_pago}}</td>
            <!-- <td>{{docto.ref_doc}}</td> -->
            <td *ngIf="docto.reversa_pago_codigo > 0" (click)="loadAndShowDetallePago(docto)" class="custom_link">{{
              docto.ref_doc }}</td>
            <td *ngIf="docto.reversa_pago_codigo === 0">{{ docto.ref_doc }}</td>
            <td>{{docto.ref_folio}}</td>
            <td>{{docto.vendedor_nombre}}</td>
            <td>{{docto.fecha_emision | fecha}}</td>
            <td>{{docto.fechaVencimientoDocto | fecha}}</td>
            <td align="right">$ {{docto.monto | numerico}}</td>
            <td align="center">$ {{docto.pago | numerico}}</td>
            <td style="width: 120px;" align="right">
              <input [(ngModel)]="docto.abono" monto (change)="doctoAbonoChange($event)" type="text" id="input11"
                class="form-control text-right" placeholder="" />
            </td>
            <td align="right">$ {{docto.deuda | numerico}}</td>
            <td class="text-center">{{docto.recorrido_codigo | numerico}}</td>
            <td align="center">
              <mdb-badge *ngIf="docto.codigo_estado_recorrido === 2" pill="true" class="estado-despachado">
                despachado</mdb-badge>
              <mdb-badge *ngIf="docto.codigo_estado_recorrido === 3" pill="true" class="estado-liquidado">
                liquidado</mdb-badge>
              <mdb-badge *ngIf="docto.codigo_estado_recorrido === 1" pill="true" class="estado-en-carga">
                en carga</mdb-badge>
            </td>
          </tr>
        </tbody>
        <tbody class="blue lighten-5">
          <tr>
            <td colspan="7"></td>
            <td align="right"><strong>Totales</strong></td>
            <td align="right"><strong>$ {{documentosPendientesTotales.total_monto | numerico }}</strong></td>
            <td align="right"><strong>$ {{documentosPendientesTotales.total_pago | numerico}}</strong></td>
            <td align="right"><strong>$ {{documentosPendientesTotales.total_abono | numerico}}</strong></td>
            <td align="right"><strong>$ {{documentosPendientesTotales.total_deuda | numerico}}</strong></td>
            <td colspan="2"></td>
          </tr>
        </tbody>
      </table>
    </div>
    <div class="row filtros-body">
      <div class="col">
        <h5>Pagos a cuentas</h5>
      </div>
    </div>
    <div [ngClass]="{'table-responsive': true, disabledContent: !enabled}">
      <table class="table table-striped table-hover table-sm align-middle">
        <thead class="grey lighten-2">
          <tr>
            <th scope="col">
              <mdb-checkbox (change)="checkAllPagosACuenta($event)"></mdb-checkbox>
            </th>
            <th scope="col">Nro. Doc.</th>
            <th scope="col">Tipo pago a cuenta</th>
            <th scope="col">Ref. Doc. Nro.</th>
            <th scope="col" class="text-right">Fecha Doc.</th>
            <th scope="col" class="text-right">Monto</th>
            <th scope="col" class="text-right">Pago a cuenta a utilizar</th>
          </tr>
        </thead>
        <tbody>
          <tr *ngFor="let pago of pagosACuentas">
            <td>
              <mdb-checkbox [checked]="pago.seleccion" (change)='checkPagoACuenta(pago)'></mdb-checkbox>
            </td>
            <td>{{pago.folio}}</td>
            <td>{{pago.tipo_pago_cuenta_nombre}}</td>
            <td>{{pago.referencia_documento}}</td>
            <td>{{pago.fecha_doc | fecha}}</td>
            <td align="right">$ {{pago.saldo | numerico}}</td><!-- Saldo muestra el monto -->
            <td style="width: 200px;" align="right">
              <input [disabled]="documentosPendientesTotales.total_abono >= pago.saldo"
                *ngIf="pago.tipo_pago_cuenta_codigo === 2 || pago.tipo_pago_cuenta_codigo === 1 || pago.tipo_pago_cuenta_codigo === 3"
                type="text" id="input12" class="form-control text-right" placeholder=""
                [ngModel]="pago.pago_cuenta_utilizado | numero" (ngModelChange)="pago.pago_cuenta_utilizado=$event"
                monto (change)="pagoCuentaUtilizadoChange($event)" />
            </td>
          </tr>
        </tbody>
        <tbody class="blue lighten-5">
          <tr>
            <td align="right" colspan="5">
              <strong>Total de pago a cuenta</strong>
            </td>
            <td align="right"><strong>$ {{pagosACuentasTotales.total_pago_cuenta | numerico}}</strong></td>
            <td align="right"><strong>$ {{pagosACuentasTotales.total_pago_cuenta_utilizado | numerico}}</strong></td>
          </tr>
        </tbody>
      </table>
    </div>
  </div>
  <!-- FOOTER -->
  <div
    [ngClass]="{'card-footer text-muted filtros-footer justify-content-end align-items-center': true, disabledContent: !enabled}"
    style="border-top: 1px solid #dee2e6;">
    <h6><strong>Diferencial a pagar </strong>$ {{pagosACuentasTotales.diferencial_pagar | numerico}}</h6>

    <button mdbBtn type="button" size="sm" color="secondary" mdbWavesEffect (click)="conformeAbono()"
      [disabled]="disableBtnMontoConforme">
      Continuar
    </button>
  </div>
</div>

<!-- MODAL seleccionarCliente -->
<app-modal-seleccionar-cliente [multiple]="false" queryType="VENDEDOR" [vendedorCodigo]="vendedor_codigo"
  (onSelectSingle)="onClienteByVendedorSeleccionado($event)" (onNotFound)="onClienteByVendedorNoEncontrado()">
</app-modal-seleccionar-cliente>

<!-- MODAL verPago-->
<app-modal-view-details-pago></app-modal-view-details-pago>

<!-- MODAL verErrores -->
<app-modal-folios-liquidacion></app-modal-folios-liquidacion>
